export const RECEIVE_NEW_MESSAGE = 'RECEIVE_NEW_MESSAGE';
export const SEND_NEW_MESSAGE = 'RECEIVE_NEW_MESSAGE';
export const SET_CONNECTION_STATUS = 'SET_CONNECTION_STATUS';
export const READ_CHAT = 'READ_CHAT';

export const SET_SOCKET_CONNECTION = 'SET_SOCKET_CONNECTION';
export const CLOSE_SOCKET_CONNECTION = 'CLOSE_SOCKET_CONNECTION';

export const SET_CHAT_HISTORY = 'SET_CHAT_HISTORY';

export const SET_CHAT_NOTIFICATION = 'SET_CHAT_NOTIFICATION';
export const SET_CHAT_NOTIFICATION_HISTORY = 'SET_CHAT_NOTIFICATION_HISTORY';
export const MARK_AS_READ = 'MARK_AS_READ';
export const MARK_ALL_AS_READ = 'MARK_ALL_AS_READ';
